import React from "react";
import { useFetch } from "hooks/api";
import { Row, Col, Table } from "react-bootstrap";
import moment from "moment";
import Loading from "components/core/blocks/Loading";
import { formatCurrency } from "utils/formatNumber";
import { useAppSelector } from "redux/hooks";

const BudgetProgramLog = ({ advertisementId }) => {
  const logQueryFilters = {
    advertisement: advertisementId,
    only_action: true,
  };

  const { marketPlace } = useAppSelector((state) => state.marketPlace);

  const { data, isLoading } = useFetch(
    ["program_logs_advertisement_budgets", advertisementId],
    `/programlogs/advertisement_budgets/`,
    logQueryFilters,
    { select: (data) => data?.data?.results ?? [] },
  );
  const captalize = (str) => {
    if (!str) return null;
    str = str.toLowerCase().replaceAll("_", " ");
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <>
      <Row className="pt-5">
        <Col>
          <div className="pb-3">
            <span className="fs-4 fw-bold">Rule Logs</span>
          </div>
        </Col>
      </Row>
      <Row className="pb-3">
        <Col>
          {isLoading && <Loading height={"300px"} fullPage={false} />}
          {!isLoading && (
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Program</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((log, i) => {
                  return (
                    <tr key={i}>
                      <td>{moment(log.ts).format("YYYY-MM-DD HH:mm:ss")}</td>
                      <td>
                        {log?.program?.name} ({log?.program?.id})
                      </td>
                      <td>
                        {log?.action?.length === 0 && "N/A"}
                        {log?.action?.map((action, i) => {
                          return (
                            <div key={i} style={{ marginBottom: "5px" }}>
                              <span className="fw-bold">{captalize(action?.function)}</span>
                              :&nbsp;
                              {action?.next_budget && (
                                <span className="fw-light">
                                  New: {formatCurrency(action?.next_budget, marketPlace)} - Prev:{" "}
                                  {formatCurrency(action?.current_budget, marketPlace)}
                                </span>
                              )}
                              {action?.next_percentage && (
                                <>
                                  {action?.placement && (
                                    <>
                                      <span className="fw-light">
                                        {{
                                          PLACEMENT_TOP: "Top of Search",
                                          PLACEMENT_REST_OF_SEARCH: "Rest of Search",
                                          PLACEMENT_PRODUCT_PAGE: "Detail Page",
                                        }?.[action?.placement] ?? action?.placement}
                                      </span>
                                      , &nbsp;
                                    </>
                                  )}
                                  <span className="fw-light">
                                    New: {action?.next_percentage}% - Prev: {action?.current_percentage}%
                                  </span>
                                </>
                              )}
                            </div>
                          );
                        })}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </Col>
      </Row>
    </>
  );
};

export default BudgetProgramLog;
